/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { FormStructure } from '@master/model/structure/FormStructure'
import { FormBaseMixin } from './FormBaseMixin'
import { RecruitManagerAssessment, RecruitManagerAssessmentFields, ReportingTier } from '@core/model/recruit/forms/RecruitManagerAssessment'
@Component
export class RecruitManagerAssessmentMixin extends FormBaseMixin {
  protected type = RecruitManagerAssessment

  get companyShortName () {
    return this.projectInfo.companyShortName
  }

  get companyLongName () {
    return this.projectInfo.companyLongName
  }

  get repInfoStructure (): FormStructure<RecruitManagerAssessmentFields> {
    return [
      {
        label: 'Agent Channel',
        key: 'channel'
      },
      {
        label: 'Agent reporting hierarchy',
        key: 'reporting',
        type: 'smart',
        options: ReportingTier
      },
      {
        label: 'Recruiting Manager',
        key: 'manager'
      }
    ]
  }

  get bandInfoStructure (): FormStructure<RecruitManagerAssessmentFields> {
    return [
      {
        label: 'Representative’s Banding (%)',
        key: 'banding',
        type: 'number'
      },
      {
        label: 'Banding Expiry Date',
        key: 'bandingExpiry',
        type: 'date'
      },
      {
        label: 'FSM’s Banding (%) (Please specify if appointed as a FSM)',
        key: 'fsmBanding',
        type: 'number'
      },
      {
        label: 'Designation',
        key: 'designation'
      }
    ]
  }

  get rcmdInfoStructure (): FormStructure<RecruitManagerAssessmentFields> {
    return [
      {
        label: 'Recruiting Manager’s Recommendations',
        key: 'rcmdNote',
        type: 'textarea'
      }
    ]
  }
}
